module.exports = "<div #component [id]=\"uniqueID\" *ngIf=\"safeHtml\" [innerHtml]=\"safeHtml\"></div>";